module.exports = __webpack_public_path__ + "static/media/Figures-Acceleration.bbf6a1f5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/Figures-Acceleration.jpeg
// module id = 250
// module chunks = 0